import ApiService from "../../api/api.service";
import {GET_COMMODITY_KEEP_SAFE_DATA, SAVE_COMMODITY_KEEP_SAFE_DATA} from "../actions.type";

	const getCommodityKeepSafeState = () => {
		return {
			commodityKeepSafeData: {}
		}
	};

	const state = getCommodityKeepSafeState();
	const getters = {
		getCommodityKeepSafeDetail(state) {
			return state.commodityKeepSafeData;
		}
	};

	const mutations = {
		setCommodityKeepSafeData(state, data){
			state.commodityKeepSafeData = data
		}
	};


	const actions = {
		[GET_COMMODITY_KEEP_SAFE_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();
				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}
					context.commit('setCommodityKeepSafeData',data);
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				if(response.logout == true){
					window.location.replace('/');
				}
			});
		},

		[SAVE_COMMODITY_KEEP_SAFE_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}
					resolve();
				})
				.catch(({ response }) => {
					console.log(response,'post');
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true){
					window.location.replace('/');
				}
				console.log(response);
			});
		},
	};

	export default {
		getters,
		actions,
		mutations,
		state
	}